module.exports = __webpack_public_path__ + "img/NanoReactor.7edf660a.jpg";